<template>
    <div class="main-content">
        <div class="container-fluid p-0">
            <div class="dax-search-content">
                <div class="row">
                    <div class="col-12">
                        <div class="board-main-content">
                            <div class="board-wrapper">
                                <div class="board-heading">
                                    <div class="heading">
                                        <textarea-autosize v-model="board.name"
                                                           class="form-control col-12 board-input-title"
                                                           @blur.native="updateBoardProperty($event, 'name')"
                                                           rows="1"
                                        ></textarea-autosize>
                                        <textarea-autosize v-model="board.description"
                                                           class="board-input-description"
                                                           @blur.native="updateBoardProperty($event, 'description')"
                                                           rows="1"
                                        ></textarea-autosize>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class=" col-12 col-md-12 col-lg-9 source-list-part mb-3">
                                        <BoardColumn
                                            v-for="(column, $columnIndex) of board.columns"
                                            :key="$columnIndex"
                                            v-bind:column="column"
                                            :columnIndex="$columnIndex"
                                            v-bind:board="board"
                                            class="pipeline-col"
                                            :class="{ 'ml-0': $columnIndex === 0 }"
                                        />

                                        <div class="board-list-wrapper add-col" v-if="enableExtraClick">
                                            <div class="create-new-column">
                                                <div class="board-add-card align-items-center">
                                                    <a @click="enableColumnTx()" >
                                                        <span style="display: block;">Create New Column</span>
                                                        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill="#6E7077" d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7a1 1 0 010-2h10a1 1 0 110 2zm-5 5a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1z"/>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="board-list-wrapper add-col" v-if="!enableExtraClick">
                                            <div class="board-list-box" style="width: 100%;">
                                                <div class="board-list-header">
                                                    <textarea
                                                        ref="columnTextArea"
                                                        class="board-cart-name"
                                                        placeholder="Column Title"
                                                        autofocus
                                                        @keyup.enter="$event.target.blur()"
                                                        @blur="createColumn($event)"
                                                        @keyup.esc="enableExtraClick = true"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-3 power-bi-logo">
                                        <div class="power-bi-logo-header"></div>
                                        <img src="/assets/img/Power-BI.png" class="" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DocumentContent />
        <router-view />
        <v-dialog :clickToClose="false" :width="500"
                  :adaptive="true" :max-width="'80%'" />
        <doc-clone-name v-if="settingCloneTitle" :tinyMceOff="'on'"></doc-clone-name>
    </div>
</template>

<script>
import BoardColumn from "./BoardColumn";
import BackLog from "./BackLog";
import Drag from "./Drag";
import Drop from "./Drop";
import BacklogTask from "./BacklogTask";
import store from "../../store/modules/pipeline-planner";
import {mapState} from "vuex";
import DocumentHttpService from "../../services/DocumentHttpService";
import TaskPopup from "../analytics-planner/TaskPopup";
import DocumentContent from "./../DocumentContent";
import ApiService from "../../api/api.service";
import vmodal from 'vue-js-modal'
import DocCloneName from "./../DocCloneName";
import pipelineBoard from "../../store/modules/pipeline-board";

export default {
    name: "PipelinePlanner",
    components: {
        BoardColumn,
        BackLog,
        Drop,
        Drag,
        BacklogTask,
        TaskPopup,
        vmodal,
        ApiService,
        DocCloneName,
        DocumentContent
    },
    data: () => {
        return {
            docService: new DocumentHttpService(),

            titleEdit: false,
            descriptionEdit: false,

            enableExtraClick: true,
            dirty: false,
            docDbId: null,
            user: null,
            entity_id: null,


            lockedForEditing: false,
            settingCloneTitle: false,
        }
    },
    beforeCreate() {
        this.$store = store; // No way around this
    },

    computed: {
        ...mapState(['board']),
    },
    mounted() {
        const titleEl = document.querySelector('head title');
        titleEl.textContent = 'Data Pipeline Planner - Analyst Hub by Enterprise DNA';

        // Cloning
        if(this.$route.query.clone) {
            this.settingCloneTitle = true;
        }

        if(this.$route.params.doc_id) {
            this.loadData(this.$route.params.doc_id);
        } else {
            // new doc
            this.checkPaidPlanAccess();

            this.$store.commit('LOAD_DATA', { data: pipelineBoard});
        }
    },
    methods: {
        createColumn(e) {
            this.$store.commit('CREATE_COLUMN', {
                name: e.target.value
            })

            this.enableExtraClick = true;
        },
        loadData(id) {
            this.docService.get(id)
                .then(({data}) => {
                    if(data.doc) {
                        this.checkPaidPlanAccess(data.doc.latest_three);

                        const titleEl = document.querySelector('head title');
                        titleEl.textContent = data.doc.name + ' - Analyst Hub by Enterprise DNA';

                        this.$store.commit('LOAD_DATA', {
                            data: {
                                document_db_id: data.doc.id,
                                document_url_id: data.doc.document_id,
                                entity_id: data.entity.id,
                                name: data.doc.name,
                                description: data.doc.description,
                                entity_name: 'Pipeline Planner',
                                entity_group: 'Pipeline Planner',
                                columns: data.entity.data || [],
                                user: data.doc.user,
                                team_id: data.doc.team_id || null,
                                team_shared: data.doc.team_shared || false,
                                created_at: data.doc.created_at,
                            }
                        });

                        if(data.doc.team_shared) {
                            this.getLockedStatus();
                        }


                    } else {
                        this.$router.push({'name': 'Data Pipeline Planner'});
                    }



                })
                .catch((response) => {
                    console.log(response);
                });
        },
        updateBoardProperty(e, key) {
            this.$store.commit('UPDATE_BOARD', {
                key,
                value: e.target.value
            })
        },
        enableColumnTx() {
            this.enableExtraClick = false;
            setTimeout(() => {
                this.$refs.columnTextArea.focus()
            })
        },

        checkPaidPlanAccess(latestThree) {
            // restriction check
            this.userData = JSON.parse(localStorage.getItem('user'));
            if(typeof latestThree == 'undefined') {
                if(this.userData.free_plan && this.userData.documents_count >= 3) {
                    this.$router.push({ name: 'Documents Limit'});
                }
            } else {
                if(this.userData.free_plan && !latestThree) {
                    this.$router.push({ name: 'Documents Limit'});
                }
            }
        },

        // get document locked status
        getLockedStatus() {

            if(this.board.team_shared) {
                ApiService.setHeader();
                ApiService.get('/api/locked-status/' + this.$route.params.doc_id)
                    .then(({data}) => {
                        this.lockedForEditing = data.locked;
                        if(data.locked) {
                            this.$modal.show('dialog', {
                                title: '&nbsp;',
                                text: '<p class="text-center"><strong>' + data.user.name + '</strong> may still be editing this document.</p>' +
                                    '<p class="text-center">Currently, only one team member can edit a document simultaneously. You can force takeover to start editing, or go back if you believe ' + data.user.name + ' is currently editing on the document.</p>',
                                buttons: [
                                    {
                                        title: 'Go back',
                                        handler: () => {
                                            this.$router.back();
                                        }
                                    },
                                    {
                                        title: '<span class="text-danger">Take over</span>',
                                        handler: () => {

                                            ApiService.setHeader();
                                            ApiService.get('/api/takeover-locked-status/' + this.$route.params.doc_id)
                                                .then(({data}) => {
                                                    this.$modal.hide('dialog');
                                                })
                                                .catch((response) => { console.log(response) });
                                        }
                                    }
                                ]
                            })

                        }
                    })
                    .catch((response) => {
                        console.log(response)
                    });
            }
        },

        saveDoc(data, entity_data) {
            let formData = data;
            formData.document_id = this.board.document_url_id;

            ApiService.setHeader();
            ApiService.post('/api/document/clone', formData)
                .then(({data}) => {
                    this.$router.push({'name': 'Data Pipeline Planner', params: {doc_id: data.doc.document_id}} )
                    this.loadData(data.doc.document_id);
                    setTimeout(() => {
                        this.settingCloneTitle = false;
                    }, 2000);
                })
                .catch((response) => { console.log(response) })
        },
    }
}
</script>

<style scoped>
.power-bi-logo {
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 20%);
    padding: 0 20px;
    border-radius: 6px;
    margin: auto;
    max-width: fit-content;
}
.power-bi-logo-header {
    background: #d8d8d8;
    height: 50px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin: auto -20px;
}
.power-bi-logo img {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}
.create-new-column {
    top: 170px;
    position: absolute;
}

.pipeline-col {
    min-width: 45%;
}

.add-col {
    min-width: 45%;
    display: flex;
    justify-content: center;
    min-height: 400px;
}

@media (max-width: 991px) {
    .pipeline-col {
        min-width: 70%;
    }
    .add-col {
        min-width: 75%;
        display: flex;
        justify-content: center;
    }
}

@media (min-width: 992px) {
    .source-list-part {
        overflow-x: auto;
        max-width: 66%;
        display: flex;
    }

}

@media (max-width: 991px) {
    .source-list-part {
        overflow-x: auto;
        max-width: 100%;
        display: flex;
    }
    .power-bi-logo {
        margin: 20px 15px;
    }
}


:root {
    touch-action: pan-x pan-y;
    height: 100%
}

.container-fluid {
    min-height: 80vh;
    height: 80vh;
    overflow-y: scroll;
}
@media screen and (min-width: 1200px) {
    .container-fluid {
        min-height: 65vh;
        height: 65vh;
        overflow-y: scroll;
    }
}

</style>
